function ServiceCard({ icon, title, text, id }) {
	return (
		<div className="serviceCard">
			<div className="iconContainer">
				<i className={icon}></i>
			</div>
			<h3>{title}</h3>
			<p>{text}</p>
		</div>
	);
}

export default ServiceCard;
